


import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { HouseConfiguration } from '@/utils/api';
import { RouteNames } from '@/utils/router/router.models';
import type { InfoPayload } from '@/store/modules/notify';

const appModule = namespace('app');
const configurationModule = namespace('configuration');
const notifyModule = namespace('notify');

@Component({})
export default class ClickableLogo extends Vue {
  @appModule.State private locale!: string;
  @configurationModule.State private houseConfiguration!: HouseConfiguration;
  @notifyModule.Action private openInfoModal!: (infoPayload: InfoPayload) => Promise<void>;

  @appModule.Action private updateLocale!: (payload: { locale: string; isInitial?: boolean }) => void;

  @Prop({ default: false }) private showLink!: boolean;

  private RouteNames: typeof RouteNames = RouteNames;

  private get langFromLocale() {
    return this.locale.split('-')[0];
  }

  private toggleLocale() {
    this.updateLocale({ locale: this.locale === 'de-DE' ? 'en-GB' : 'de-DE' });
  }

  private handleHomeClick() {
    this.openInfoModal({
      headline: this.$t('global.dialogs.homeConfiguration.headline'),
      message: this.$t('global.dialogs.homeConfiguration.message'),
      declineCta: this.$t('global.dialogs.homeConfiguration.declineCta'),
      acceptCta: this.$t('global.dialogs.homeConfiguration.acceptCta')
    }).then(() => {
      window.location.href = this.$t('global.dialogs.homeConfiguration.target').toString();
    });
  };

  @Emit()
  private openCodeModal() {
    return;
  }
}
